<template>
  <AuthCard>
    <div class="text-center">
      <h1 class="h4 mb-3">
        Check your email
      </h1>
      <p class="mb-0" data-test="success-message">
        We sent a password reset link to your inbox. If it doesn't arrive in a few minutes, check your spam folder.
      </p>
    </div>
  </AuthCard>
</template>

<script setup>
import AuthCard from './components/AuthCard.vue';
</script>
